export enum LoginModalMode {
    LOGIN = 'Login',
    REGISTER = 'Register',
    REGISTER_SUCCESS = 'RegisterSuccess',
    FORGOT_PASSWORD = 'ForgotPassword',
    PASSWORD_RESET = 'PasswordReset',
}
